@if (canReplay) {
<div class="replay-container">
    <div class="replay-header">
        <h3 class="section-title">
            <mat-icon>replay</mat-icon>
            Replay Missed Entries
        </h3>
        <button mat-stroked-button (click)="loadPreview()" [disabled]="isLoading() || isSubmitting()">
            @if (isLoading()) {
            <mat-spinner diameter="16"></mat-spinner>
            } @else {
            <mat-icon>search</mat-icon>
            }
            Check
        </button>
    </div>

    @if (isLoading()) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    }

    @if (preview(); as p) {
    <div class="replay-summary">
        <span class="count-badge">{{ p.replayCount }} to replay</span>
        @if (isRunning) {
        <span class="count-badge running">
            <mat-spinner diameter="12"></mat-spinner>
            {{ p.queuedCount }} queued
        </span>
        }
        <span class="summary-meta">{{ p.items?.length ?? 0 }} records &middot; {{ p.cameraTimeZoneId }}</span>

        <span class="spacer"></span>

        <mat-slide-toggle [checked]="showAll()" (change)="showAll.set($event.checked)">All records</mat-slide-toggle>

        @if (confirming()) {
        <button mat-button (click)="confirming.set(false)">Cancel</button>
        <button mat-flat-button color="warn" (click)="replay()">
            <mat-icon>play_arrow</mat-icon>
            Confirm {{ p.replayCount }}
        </button>
        } @else {
        <button mat-flat-button color="primary" (click)="confirming.set(true)"
            [disabled]="(p.replayCount ?? 0) === 0 || isSubmitting() || isRunning">
            @if (isSubmitting()) {
            <mat-spinner diameter="16"></mat-spinner>
            } @else {
            <mat-icon>play_arrow</mat-icon>
            }
            Replay {{ p.replayCount }}
        </button>
        }
    </div>

    @if (result(); as r) {
    <div class="result-card" [class.running]="r.queued > 0" [class.has-failures]="r.failed > 0">
        <div class="result-header">
            @if (r.queued > 0) {
            <mat-spinner diameter="16"></mat-spinner>
            <span class="result-title">Replay running</span>
            } @else {
            <mat-icon>{{ r.failed > 0 ? 'warning' : 'check_circle' }}</mat-icon>
            <span class="result-title">Replay finished</span>
            }
            <span class="result-meta">
                {{ r.startedAt | date:'dd.MM.yyyy HH:mm:ss' }}
                @if (r.finishedAt) { &rarr; {{ r.finishedAt | date:'HH:mm:ss' }} }
            </span>
        </div>

        <div class="result-totals">
            <div class="total"><span class="value">{{ r.replayed }}</span><span class="label">Replayed</span></div>
            <div class="total failed"><span class="value">{{ r.failed }}</span><span class="label">Failed</span></div>
            @if (r.queued > 0) {
            <div class="total queued"><span class="value">{{ r.queued }}</span><span class="label">Queued</span></div>
            }
        </div>

        <div class="result-breakdown">
            @if (r.outcomes.length > 0) {
            <div class="breakdown">
                <span class="breakdown-title">Outcome</span>
                @for (o of r.outcomes; track o.label) {
                <div class="breakdown-row"><span>{{ o.label }}</span><span class="count">{{ o.count }}</span></div>
                }
            </div>
            }
            @if (r.skipped.length > 0) {
            <div class="breakdown">
                <span class="breakdown-title">Skipped</span>
                @for (s of r.skipped; track s.label) {
                <div class="breakdown-row"><span>{{ s.label }}</span><span class="count">{{ s.count }}</span></div>
                }
            </div>
            }
        </div>
    </div>
    }

    @if (visibleItems().length === 0) {
    <p class="empty-hint">No missed entries.</p>
    } @else {
    <div class="table-wrapper">
        <table mat-table [dataSource]="visibleItems()" [trackBy]="trackItem" class="replay-table">

            <ng-container matColumnDef="plateNumber">
                <th mat-header-cell *matHeaderCellDef>Plate</th>
                <td mat-cell *matCellDef="let row"><span class="plate">{{ row.plateNumber }}</span></td>
            </ng-container>

            <ng-container matColumnDef="detectionTime">
                <th mat-header-cell *matHeaderCellDef>Detected</th>
                <td mat-cell *matCellDef="let row">{{ row.detectionTime | date:'dd.MM.yyyy HH:mm:ss' }}</td>
            </ng-container>

            <ng-container matColumnDef="decision">
                <th mat-header-cell *matHeaderCellDef>Decision</th>
                <td mat-cell *matCellDef="let row">
                    <mat-chip [color]="getDecisionColor(row)" [highlighted]="row.decision === Decision.Replay">
                        {{ row.decision }}
                    </mat-chip>
                </td>
            </ng-container>

            <ng-container matColumnDef="replayStatus">
                <th mat-header-cell *matHeaderCellDef>Replay</th>
                <td mat-cell *matCellDef="let row">
                    <span class="status-cell" [class]="'status-' + (row.replayStatus | lowercase)">
                        <mat-icon>{{ getStatusIcon(row.replayStatus) }}</mat-icon>
                        {{ row.replayStatus === ReplayStatus.NotReplayed ? '' : row.replayStatus }}
                    </span>
                </td>
            </ng-container>

            <ng-container matColumnDef="detail">
                <th mat-header-cell *matHeaderCellDef>Detail</th>
                <td mat-cell *matCellDef="let row" class="detail-cell">{{ row.replayResult || row.reason }}</td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
    </div>
    }
    }
</div>
}
